import React, { useState, useEffect, useContext } from "react";
import TeaserListHeader from "./TeaserListHeader";
import { MyCardsService } from "../../../utils/api";
import WsContext from "../../../context/WsContext";
import GlobalsContext from "../../../context/GlobalsContext";
import { SetHeaderState } from "../../../utils/api";
import useThis from "../../../hooks/useThis";

const TeaserListHeaderComponent = ({ setCards, cards, ...props }) => {
  const wsContext = useContext(WsContext);
  const globalsContext = useContext(GlobalsContext);
  const thisFixed = useThis(props.fixed);

  const load = () => {
    MyCardsService()
      .then(cards => {
        setCards(cards);
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    load();
    wsContext.eventEmitter.subscribe("cards_update", load);
  }, []);

  useEffect(() => {
    SetHeaderState({ fixed: props.fixed });

    if (!props.fixed) {
      window.scrollTo(0, 0);
    }

    if (props.fixed) {
      document.body.classList.add("body-fixed");
    } else {
      document.body.classList.remove("body-fixed");
    }
  }, [props.fixed]);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (pageYOffset >= 415 && !thisFixed.current) {
        props.toggleOpen();
      }
    });
  }, []);

  return (
    <TeaserListHeader
      {...props}
      cards={cards}
      permissions={globalsContext.permissions}
    />
  );
};

export default TeaserListHeaderComponent;
